import { IApplicationState } from '../../types/redux';

export function getQuestionsCount(state: IApplicationState) {
  return state.newbuildingInfo.questionsCount;
}
